import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { TableType } from '@/coreDomainsModule/table';
import { InjectionKey } from 'vue';

export type OpenModal = (business: IBusiness, key?: string) => void; // 各種モーダルを開く
export type OnPreLoadedTable = (businesses: IBusiness[]) => void; // 各種前処理用

export type OnCheckIds = (checkIds: string[], from?: TableType) => void; // アイテムが選択されたことを通知
export type OpenReceiveDeleteRequestModal = (event: string) => void;
export type OpenNoticeApprovedDeleteRequestModal = (event: string) => void;
export type OnChangeFieldInput = (info: object) => void;

// TODO: 絶対ストアでまとめた方がいい（色々ごちゃごちゃしてるのでとりあえず後回し）
export const openModalKey: InjectionKey<OpenModal> = Symbol('openModal');
export const OnPreLoadedTableKey: InjectionKey<OnPreLoadedTable> = Symbol('OnPreLoadedTable');
export const onCheckIdsKey: InjectionKey<OnCheckIds> = Symbol('onCheckIds');
export const openReceiveDeleteRequestModalKey: InjectionKey<OpenReceiveDeleteRequestModal> = Symbol('openReceiveDeleteRequestModal');
export const openNoticeApprovedDeleteRequestModalKey: InjectionKey<OpenNoticeApprovedDeleteRequestModal> = Symbol(
  'openNoticeApprovedDeleteRequestModal'
);
export const onChangeFieldInputKey: InjectionKey<OnChangeFieldInput> = Symbol('onChangeFieldInput');
